import { filter, isEmpty } from 'lodash'

import useFieldValue from '../../../../../1stlog-ui/src/components/Field/useFieldValue'

export function useIsPhoneRequired(): boolean {
  const shipmentServices: any[] = useFieldValue('shipmentServices', {
    ignorePrefix: true,
  })

  // FIXME: ignore hiddenIfOwnAddress for now - always true when phoneIsRequired is true

  return !isEmpty(
    filter(shipmentServices, {
      deliveryPhoneIsRequired: true,
      isEnabled: true,
    }),
  )
}
